// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__rk-ay","full-width":"Button_full-width__jH3P9","primary":"Button_primary__+WKs6","secondary":"Button_secondary__BIt0H","outline":"Button_outline__ZzH7a"};